import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { MaintenancePage } from './MaintenancePage';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* Wraps the whole router. Checks the public maintenance flag once on load
   (never blocks initial paint — same "don't block app boot" convention as
   BrandingProvider) and swaps in the full-screen MaintenancePage for anyone
   who isn't `role === 'admin'` while it's active. Admins always see the
   real app (their own requests already bypass the backend middleware).
   `/login` is always exempt so a logged-out admin can actually sign in. */
export const MaintenanceGate = ({ children }) => {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    axios.get(`${API}/platform/maintenance-status`)
      .then((res) => setEnabled(!!res.data?.maintenance_mode))
      .catch(() => setEnabled(false));
  }, []);

  if (!enabled || pathname === '/login') return children;
  // Avoid a maintenance-page flash for an admin whose session is still
  // resolving on reload — only matters while maintenance is actually on.
  if (loading) return null;
  if (user?.role !== 'admin') return <MaintenancePage />;
  return children;
};
